import { navigateTo, useCookie } from "#imports";
import { useUserStore } from "@voix/store/userStore";
import $voixFetch from "@voix/voix-layer/utils/$voixFetch";
import { useVoixAsyncData } from "../../voix-layer/composables/useVoixAsyncData.js";
function setCurrentUserInStore(response) {
  if (response) {
    const userStore = useUserStore();
    userStore.currentUser = response;
  }
}
const getCurrentUser = async () => {
  const userStore = useUserStore();
  const accessToken = useCookie("auth-access-token");
  if (!accessToken.value)
    return { pending: false, data: { value: null } };
  try {
    if (import.meta.server) {
      const { data: request } = await useVoixAsyncData(
        `/api/admin/voix/users/me`
      );
      setCurrentUserInStore(request);
      return request;
    } else {
      const request = await $voixFetch(
        `/api/admin/voix/users/me`
      );
      setCurrentUserInStore(request);
      return request;
    }
  } catch (error) {
    if (error.statusCode === 401) {
      userStore.logout();
      await navigateTo({
        path: "/"
      });
    }
  }
};
export { getCurrentUser };
